import { render, staticRenderFns } from "./ReportBugSidebar.vue?vue&type=template&id=11579bc8"
import script from "./ReportBugSidebar.vue?vue&type=script&lang=js"
export * from "./ReportBugSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports